import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-work-grp-menu',
  templateUrl: './work-grp-menu.component.html',
  styleUrls: ['./work-grp-menu.component.css']
})
export class WorkGrpMenuComponent implements OnInit {
    workGrpKeyno;

    public menu?: Menu;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.workGrpKeyno = this.stateService.getStateParams()['workgrp_keyno'];
    }

    private async loadMenu() {
        if (!!this.workGrpKeyno) {
            this.menu = (await this.datatask.Post(2021, { workgrp_keyno: this.workGrpKeyno }))[0];
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    workgrp_keyno: number;
    workgrp_name: string;
    active: number;
    factory_name: string;
    businessco_companyname: string;
    nbr_of_equipments: number;
}
